var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "9px",
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "quoteRight") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-7",
    transform: "translate(-248.000000, -2196.000000)",
    fill: "#7BCB45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252.551015,2197.14628 C251.460261,2198.21614 250.813429,2199.29872 250.610498,2200.39406 L252.474916,2200.39406 L252.132472,2204.36782 L248.213389,2204.36782 L248.441685,2201.57855 C248.517784,2200.50868 248.771444,2199.52162 249.202672,2198.61733 C249.6339,2197.71304 250.306099,2196.84061 251.219288,2196 L252.551015,2197.14628 Z M258.943305,2197.14628 C257.852552,2198.21614 257.20572,2199.29872 257.002789,2200.39406 L258.867207,2200.39406 L258.524763,2204.36782 L254.60568,2204.36782 L254.833976,2201.57855 C254.910075,2200.50868 255.163735,2199.52162 255.594963,2198.61733 C256.026191,2197.71304 256.698389,2196.84061 257.611578,2196 L258.943305,2197.14628 Z",
    id: "quoteRight",
    transform: "translate(253.578347, 2200.183910) rotate(-180.000000) translate(-253.578347, -2200.183910) "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteRight);
export default __webpack_public_path__ + "static/media/quoteRight.ddfba7e72a99e931a46c7da14b144f00.svg";
export { ForwardRef as ReactComponent };